import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
//-Components
import LandingHeader from "../components/LandingPageHeader";
import Service from "../components/Service";
//-Images
import AIimage from "./../assets/img/homeImages/AI.svg";
import Securityimage from "./../assets/img/homeImages/Security3.svg";
import UspImage from "./../assets/img/homeImages/USP4.svg";

const LandingPage = () => {
  return (
    <div>
      <LandingHeader />
      <Service />
      <Container className="main-section-landing">
        <Row>
          <Col xs={12} md={6}>
            <img src={AIimage} alt="internet of things" />
          </Col>
          <Col xs={12} md={6}>
            <h1>Fusing in AI to the digital age</h1>
            <p>
              With cutting technology and Machine learning, Curigma aims to
              integrate Artificial intelligence into your business. This helps
              you automate your workflow and streamline your business.
            </p>
            <Button href="/service">Learn more</Button>
          </Col>
        </Row>
        <hr />
      </Container>

      <Container className="main-section-landing">
        <Row>
          <Col xs={12} md={6}>
            <h1>Higher security standards</h1>

            <p>
              Security is the greatest factor that Curigma focuses to deliver.
              With the highest security standards, we deliver a secure digital
              solution
            </p>
            <Button href="/service">Learn more</Button>
          </Col>
          <Col xs={12} md={6}>
            <img src={Securityimage} alt="internet of things" />
          </Col>
        </Row>
        <hr />
      </Container>
      <Container className="main-section-landing">
        <Row>
          <Col xs={12} md={6}>
            <img src={UspImage} alt="internet of things" />
          </Col>
          <Col xs={12} md={6}>
            <h1>Solution to anything and everything </h1>
            <p>
              At Curigma we are curious to find complete solutions to any of
              your problems. That’s what makes us Curigma-Curious to ignite
            </p>
            <Button href="/service">Learn more</Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LandingPage;
